/*------------------------------------*\
    #FACEBOOK FEED
\*------------------------------------*/



WW.facebookFeed = function($) {
    'use strict';

console.log(ajaxurl);

    $(window).on('load', function(){
    var data = {
        'action': 'facebook'
    };
    // We can also pass the url value separately from ajaxurl for front end AJAX implementations
    jQuery.post(ajaxurl, data, function(response) {
        var facebook = jQuery(response).find('#ajax-content').html();
        jQuery("#tab-facebook").html(response);
    });
});
    return this;
};
        
// Paste into main.js: .facebookFeed($)